import React        from 'react'

const Content = props => {
    return (
        <div className="about-container-content">
            { props.children }
        </div>
    )
}

export default Content
